import { IdleQueue } from 'idlefy';

const queue = new IdleQueue({ ensureTasksRun: true });

export const delayedScheduler = (callback, timeout) => {
  // Check if requestIdleCallback is supported
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'function'
  ) {
    // Push the callback to the non-critical queue
    try {
      queue.pushTask(() => callback());
    } catch (error) {
      //eslint-disable-next-line no-console
      console.error('Exception in pushToNonCriticalQueue', error);
    }
  } else {
    // Fallback to setTimeout if requestIdleCallback is not available
    if (timeout) {
      setTimeout(callback, timeout);
    } else {
      setTimeout(callback);
    }
  }
};

export const yieldToMainThread = callback => {
  return new Promise(resolve => {
    setTimeout(() => {
      callback();
      resolve();
    }, 0);
  });
};
